import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthProvider';

import Hero from '../components/Hero';
import ProductShowcase from '../components/ProductShowcase';
import EthicalStatement from '../components/EthicalStatement';
import CategoryGrid from '../components/CategoryGrid';
import Footer from '../components/Footer';
import BestSellersSlider from '../components/BestSellersSlider';

const HomePage = () => {
const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
  if (loading) return; // ⏳ Wait until user is loaded
  if (!user) return;   // Don't redirect guests

  switch (user.role) {
    case 'admin':
      navigate('/admin/products');
      break;
    case 'factory':
      navigate('/factory');
      break;
    case 'customer-service':
      navigate('/customer-service-dashboard');
      break;
    default:
      break;
  }
}, [user, loading, navigate]);


  return (
    <div>
      <Hero />
      <EthicalStatement />
      <CategoryGrid />
      <BestSellersSlider />
      <ProductShowcase />
      <Footer />
    </div>
  );
};

export default HomePage;
